<template>
    <ul>
        <li class="root">
            <span>&nbsp;</span><span>{{anchor.key}}</span><span><a v-on:click="expanded = !expanded" href="#"><strong>{{anchor.links.length}}</strong></a></span>
        </li>
        <template v-if="expanded" v-for="value in anchor.links">
            <li class="anchor-row" v-bind:key="value.URL + value.source_URL + value.anchor"><span><a target="_blank" v-bind:href="value.URL">{{value.URL}}<external-link-icon></external-link-icon></a> <copy-link v-bind:text-to-copy="value.URL"></copy-link> </span><span><a target="_blank" v-bind:href="value.source_URL">{{value.source_URL}}<external-link-icon></external-link-icon> <copy-link v-bind:text-to-copy="value.URL"></copy-link></a></span><span></span></li>
        </template>
    </ul>
</template>

<script>
    import { ExternalLinkIcon } from 'vue-feather-icons'

    import CopyLink from '@/components/UI/_base-UI-CopyLink'

    export default {
        components: {
            ExternalLinkIcon,
            CopyLink
        },
        name: "AnchorRow",
        props:{
            anchor: Object
        },
        data: function (){
            return {
                expanded: false
            }
        },
        methods:{
            expandMe: function () {
                this.expanded = !this.expanded;
            }
        }
    }
</script>

<style scoped>
    #linkList ul li.root{
        background-color: #FFF;
        display: grid;
        grid-template-columns: 1fr 2fr 1fr;
    }

    #linkList ul li.anchor-row {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }

    #linkList ul li.root span:last-of-type{
        text-align: right;
    }

    .slide-fade-enter-active {
        transition: all .3s ease;
    }
    .slide-fade-leave-active {
        transition: all .3s ease;
    }
    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active до версии 2.1.8 */ {
        transform: scaleY(0);

    }
</style>
